import DocumentSender from "./components/DocumentSend/DocumentSend.jsx";
import CreateTemplate from "./components/TemplateCreate/TemplateCreate.jsx";
import TemplateSend from "./components/TemplateSend/TemplateSend.jsx";
import Success from "./components/Success/Success.jsx";
import TemplateMapping from "./components/TemplateMapping/TemplateMapping.jsx";
import ViewDocuments from "./components/ViewDocuments/ViewDocuments.jsx";
import TemplateConfigure from "./components/TemplateConfigure/TemplateConfigure.jsx";
import Connect from "./components/Connect/Connect.jsx";
import Disconnect from "./components/Disconnect/Disconnect.jsx";
import Error from "./components/Error/Error.jsx";
import ConfigurePropertyGroups from "./components/ConfigurePropertyGroups/ConfigurePropertyGroups.jsx";

const AppRoutes = [
  {
    path: '',
    element: <Connect />
  },
  {
    path: '/connect',
    element: <Connect />
  },
  {
    path: '/disconnect',
    element: <Disconnect />
  },
  {
    path: '/send',
    element: <DocumentSender />
  },
  {
    path: '/documentSuccess',
    element: <Success
      title="Document sent successfully"
       message="Your signature request has been sent successfully. The recipient will receive an email with a link to sign the document."
      buttonText="Close"
    />
  },
  {
    path: '/templateReady',
    element: <Success
      title="No additional setup needed"
      message="This template doesn't require setup. You can start using it from the &quot;Send Document&quot; option, or add form fields if you want to include more information."
      buttonText="Close"
    />
  },
  {
    path: '/templateConfigureSuccess',
    element: <Success
      title="Template Configured successfully"
      message='Your template setup is complete. You can now use it to send and prefill documents from the "Send Document" option.'
      buttonText="Close"
    />
  },
  {
    path: '/propertyConfigureSuccess',
    element: <Success
      title="Property Configured successfully"
      message='Your property group setup is complete. You can now use it to map your boldsign fields and prefill documents'
      buttonText="Close"
    />
  },
  {
    path: '/templateSendSuccess',
    element: <Success
      title="Document Sent Successfully"
      message="Your signature request has been sent successfully. The recipient will receive an email with a link to sign the document."
      buttonText="Close"
    />
  },
  {
    path: '/success',
    element: <Success
      title="Your BoldSign and HubSpot accounts are now connected."
      message="You can start sending documents for signature directly from your HubSpot CRM. You can close this window now."
      buttonText="Close"
    />
  },
  {
    path: '/error',
    element: <Error
      title="Connection Failed"
      message="We were unable to connect your HubSpot and BoldSign accounts. Please try again or contact support if the issue persists. You can close this window now."
      buttonText="Close"
      onButtonClick={() => {
        // Send message to parent window to close modal/iframe
        window.parent.postMessage(JSON.stringify({ action: "DONE" }), "*");
      }}
    />
  },
  {
    path: '/createTemplate',
    element: <CreateTemplate />
  },
  {
    path: '/sendTemplate',
    element: <TemplateSend />
  },
  {
    path: '/templateMapping',
    element: <TemplateMapping />
  },
  {
    path: '/viewDocuments',
    element: <ViewDocuments/>
  },
  {
    path: '/configureTemplates',
    element: <TemplateConfigure/>
  },
  {
    path: '/configurePropertyGroups',
    element: <ConfigurePropertyGroups/>
  },
];

export default AppRoutes;
